export default __webpack_public_path__ + "static/media/logo.b48a03c4.svg";